import React from 'react';
import { createRoot } from 'react-dom/client';
import { config } from './helpers/configs';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './context';

const ENV_SUFFIX = config.TEST_ENV ? '-test' : '';

document.querySelector('#manifest-placeholder')?.setAttribute(
  'href',
  `manifest${ENV_SUFFIX}.json`,
);
document.querySelector('#favicon-placeholder')?.setAttribute(
  'href',
  `assets/icon/favicon${ENV_SUFFIX}.png`,
);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  // <React.StrictMode>
    <AppProvider />
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
